const MS_PER_DAY = 86_400_000

export type DeadlineStatus =
	| { kind: 'none' }
	| { kind: 'onTime' }
	| { kind: 'overdue'; days: number }

const startOfUtcDay = (value: Date) =>
	Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate())

/** Compara o prazo com hoje por dia (UTC), igual ao cálculo feito no export do backend. */
export function getDeadlineStatus(
	dueDate: string | undefined,
	now: Date = new Date(),
): DeadlineStatus {
	if (!dueDate || Number.isNaN(Date.parse(dueDate))) return { kind: 'none' }

	const days = Math.floor(
		(startOfUtcDay(now) - startOfUtcDay(new Date(dueDate))) / MS_PER_DAY,
	)
	return days > 0 ? { kind: 'overdue', days } : { kind: 'onTime' }
}
